// =============================================================================
// features/sales/campaigns/detail/tabs/ActivityTab.tsx — Aba "Atividade":
// linha do tempo administrativa e operacional (doc 26 §6.7).
//
// LIMITAÇÃO CONHECIDA (mesma norma de useCampaigns.ts/CampaignsIndicators.tsx
// — "sem cálculo/fabricação no cliente"): não existe hoje um endpoint de
// auditoria POR CAMPANHA acessível a quem só tem `sales_campaigns:read`/
// `manage`. O único endpoint de auditoria do produto (`GET
// /api/reports/audit`, F23-S08) é agregado por ação/tipo de recurso — não um
// timeline por entidade — e exige `audit:read` (papel admin/gestor_geral),
// piso mais alto que o resto desta tela. Compor um timeline aqui a partir de
// outras chamadas (ex.: tentativas de contato) representaria só uma fatia
// operacional, disfarçada de auditoria completa — pior que ser honesto sobre
// a ausência. A aba fica reachável (estado explícito) mas SEM dados
// inventados, com a mesma linguagem de "Indisponível" usada no resto do
// módulo. Quando um slot de backend publicar o endpoint, só este arquivo
// muda.
// =============================================================================

import * as React from 'react';

export function ActivityTab(): React.JSX.Element {
  return (
    <div
      className="rounded-md border border-border overflow-hidden"
      style={{ background: 'var(--bg-elev-1)', boxShadow: 'var(--elev-1)' }}
    >
      <div className="flex flex-col items-center gap-3 py-16 text-center px-4">
        <svg
          viewBox="0 0 48 48"
          fill="none"
          stroke="currentColor"
          strokeWidth={1}
          className="w-12 h-12 text-ink-4"
          aria-hidden="true"
        >
          <path d="M24 6v12l8 8" strokeLinecap="round" strokeLinejoin="round" />
          <circle cx="24" cy="24" r="18" />
        </svg>
        <div className="flex flex-col gap-1">
          <p
            className="font-display font-semibold text-ink"
            style={{ fontSize: 'var(--text-base)', letterSpacing: '-0.02em' }}
          >
            Linha do tempo indisponível
          </p>
          <p className="font-sans text-sm text-ink-3 max-w-sm">
            Nenhum endpoint publica ainda o histórico administrativo e operacional desta campanha
            por id. As ações de pausar, retomar e editar continuam sendo auditadas — só não têm uma
            visualização por campanha nesta tela ainda.
          </p>
        </div>
      </div>
    </div>
  );
}
